<template>
  <component :is="path ? 'n-link' : 'div'" v-bind="props" class="bcbt">
    {{ value }}
  </component>
</template>

<script>
export default {
  computed: {
    props() {
      if (this.path) {
        return {
          target: this.newTab ? '_blank' : false,
          title: this.value,
          to: {
            path: this.localePathName(this.path),
            query: this.query,
          },
        }
      }
      return {}
    },
  },
  props: {
    newTab: {
      default: false,
      type: Boolean,
    },
    path: {
      default: '',
      type: String,
    },
    query: {
      default: () => ({}),
      type: Object,
    },
    value: {
      required: true,
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.bcbt {
  @apply text-cbody2 font-cbody2;
}
a.bcbt {
  @apply underline text-indigo;
}
</style>
